export default "__VITE_PUBLIC_ASSET__3c8f8772__"